<template>
  <footer class="footer" style="z-index: 2">
    <b-container fluid>
      <b-row>
        <b-col col sm="6">
          {{ new Date().getFullYear() }} © SMART INDUSTRIAL PARK
        </b-col>
        <b-col col sm="6" class="text-end">
          <div>Phát triển bởi Công ty IOTLink</div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>
